import { ITableConfig } from "@/components/table/table.model";
import { SORTING_DIR } from "@/common/models";
/* 
 "file_name": "hourly time sheet 100mb.xlsx",
  "bucket_name": "cao-verify-spaces-large-files",
  "folder_name": "root",
  "access": "public",
  "region": "ap-southeast-2",
  "created_at": "02/21/2024 04:08:26"
*/
export const table_config: ITableConfig = {
  columns: [
    {
      name: "",
      key: "",
      sortable: false,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "3rem",
      spanMax: "3rem",
    },
    {
      name: "File Name",
      key: "file_name",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "20rem",
      spanMax: "1fr",
    },
    {
      name: "Bucket & Folder",
      key: "bucket_name",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "10rem",
      spanMax: "1fr",
    },

    /*  {
      name: "Folder Name",
      key: "folder_name",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "15rem",
      spanMax: "1fr",
    }, */
    {
      name: "Access",
      key: "access",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "10rem",
      spanMax: "10rem",
    },
    {
      name: "Region",
      key: "region",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "10rem",
      spanMax: "10rem",
    },
    {
      name: "Created At",
      key: "created_at",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "10rem",
      spanMax: "10rem",
    },
  ],
};
